var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { "v-if": _vm.isInRole(["admin"]) } },
    [
      _c("toolbar"),
      _vm._v(" "),
      _c("zlick-navigation"),
      _vm._v(" "),
      _c(
        "v-container",
        [
          _c(
            "v-layout",
            { attrs: { row: "", wrap: "", center: "" } },
            [
              _c(
                "v-flex",
                { attrs: { xs12: "", "offset-xs0": "" } },
                [
                  _c(
                    "v-form",
                    { ref: "addUser", attrs: { "lazy-validation": "" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          type: "email",
                          name: "user_email",
                          "validate-on-blur": "",
                          rules: [
                            function(v) {
                              return !!v || _vm.$t("email_required")
                            }
                          ],
                          label: _vm.$t("user_email"),
                          placeholder: _vm.$t("placeholderemail"),
                          required: ""
                        },
                        model: {
                          value: _vm.user_email,
                          callback: function($$v) {
                            _vm.user_email = $$v
                          },
                          expression: "user_email"
                        }
                      }),
                      _vm._v(" "),
                      _c("v-select", {
                        attrs: {
                          items: _vm.options,
                          "menu-props": { maxHeight: "400" },
                          label: "Roles",
                          placeholder: _vm.$t("placeholderrole"),
                          multiple: "",
                          chips: ""
                        },
                        model: {
                          value: _vm.roles,
                          callback: function($$v) {
                            _vm.roles = $$v
                          },
                          expression: "roles"
                        }
                      }),
                      _vm._v(" "),
                      _c("v-btn", { on: { click: _vm.addUser } }, [
                        _vm._v(_vm._s(_vm.$t("updateuser")))
                      ]),
                      _vm._v(" "),
                      _c("v-btn", { on: { click: _vm.back } }, [
                        _vm._v(_vm._s(_vm.$t("back")))
                      ]),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _c("br")
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b4e9faf6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b4e9faf6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/editUser.vue
// module id = null
// module chunks = 